<template>
  <div class="users">
    <page-header title="Users" icon="users">
      <div slot="sub-title">
        User management
      </div>
      <div slot="controls">
        <el-button type="primary" icon="el-icon-plus" class="white-button" @click="showDialog = true" plain>Add user</el-button>
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding mobile-padding">
      <el-col :span="24" v-loading="loading">
        <el-table :data="users" v-if="!loading" @cell-click="gotoUser">
          <el-table-column label="E-mail" class="cursor-pointer">
            <template slot-scope="scope">
              {{ scope.row.email }}
              <el-tag class="system-tag" type="info" v-if="scope.row.id === $auth.user.id" size="mini">You</el-tag>
              <el-tag class="system-tag" v-if="scope.row.isSystem" size="mini">System user</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Name" prop="name" />
          <el-table-column
            fixed="right"
            width="110">
              <template slot-scope="scope">
                <table-control
                  icon="user-lock"
                  dialogTitle="Organization roles"
                  dialogWidth="300px"
                  dialog-padding
                  :obj="scope.row">
                    <template slot-scope="props">
                      <user-permission-form :user="props.obj" />
                    </template>
                </table-control>
                <table-control
                  icon="el-icon-edit"
                  dialogTitle="Edit user"
                  dialogWidth="400px"
                  dialog-padding
                  :obj="scope.row"
                  @update="update">
                    <template slot-scope="slotProps">
                      <upsert-form :user="slotProps.obj" @update="slotProps.update" />
                    </template>
                </table-control>
              </template>
            </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" append-to-body width="400px" title="Add user" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" @add="created" />
    </el-dialog>
  </div>
</template>

<script>
import UpsertForm from './UpsertForm'
import UserPermissionForm from './UserPermissionForm'
import TableControl from '@/components/shared/TableControls'

export default {
  components: { UpsertForm, TableControl, UserPermissionForm },
  name: 'Users',
  data () {
    return {
      loading: true,
      showDialog: false,
      users: []
    }
  },
  methods: {
    gotoUser(row, col) {
      if (col.label !== undefined) {
        this.$router.push({ name: 'User', params: { id: row.id } })
      }
    },
    created (user) {
      this.users.unshift(user)
      this.showDialog = false
    },
    update (user, updated) {
      const index = this.users.indexOf(user)
      for (let k in updated) {
        this.users[index][k] = updated[k]
      }
    },
    async getUsers () {
      const response = await this.$http.get(this.$api.users.index)
      this.users = response.data
      this.loading = false
    }
  },
  created () {
    this.getUsers()
  }
}
</script>

<style lang="scss" scoped>
  .system-tag {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/Users.vue